import createPredicateIndexFinder from './_createPredicateIndexFinder.js';

// Returns the last index on an array-like that passes a truth test.
export default createPredicateIndexFinder(-1);



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/findLastIndex.js
// module id = 523
// module chunks = 106